import React, {useState} from 'react';
import SkillsList from './SkillsList';

const frontEndSkills = [
    {title: 'HTML', level: '98%'},
    {title: 'CSS', level: '85%'},
    {title: 'JavaScript', level: '83%'},
    {title: 'JQuery', level: '80%'},
    {title: 'React JS', level: '70%'},
];

const backEndSkills = [
    {title: 'PHP', level: '80%'},
    {title: 'Laravel', level: '75%'},
    {title: 'Node JS', level: '65%'},
    {title: 'MySQL', level: '70%'},
    {title: 'MongoDB', level: '65%'},
];

const cloudSkills = [
    {title: 'AWS S3', level: '65%'},
    {title: 'AWS EC2', level: '60%'},
    {title: 'Docker', level: '50%'}
];

const Skill = () => {
    const [frontEndTab, setFrontEndTab] = useState(true);
    const [backEndTab, setBackEndTab] = useState(false);
    const [cloudTab, setCloudTab] = useState(false);

    const toggleFrontTab = () => {
        if (frontEndTab) {
            setFrontEndTab(false);
        } else {
            setFrontEndTab(true);
        }
    }

    const toggleBackTab = () => {
        if (backEndTab) {
            setBackEndTab(false);
        } else {
            setBackEndTab(true);
        }
    }

    const toggleCloudTab = () => {
        if (cloudTab) {
            setCloudTab(false);
        } else {
            setCloudTab(true);
        }
    }
    
    
    return (
        <section className='skills section' id='skills'>
            <h2 className="section__title">Skills</h2>
            <span className="section__subtitle">Technical strength</span>
            <div className="skills__container container grid" id='skill-con'>
                {/* front end */}
                <div className={frontEndTab ? 'skills__content skills__open' : 'skills__content skills__close'} onClick={toggleFrontTab}>
                    <div className="skills__header">
                        <i className="uil uil-brackets-curly skills__icon"></i>

                        <div>
                            <h2 className="skills__title">Frontend Development</h2>
                        </div>
                        <i className="uil uil-angle-down skills__arrow"></i>
                    </div>

                    <div className="skills__list grid">
                        {
                            frontEndSkills.map((item, idx) => (
                                <SkillsList key={idx} value={item}/>
                            ))
                        }
                    </div>

                </div>

                {/* backend */}
                <div className={backEndTab ? 'skills__content skills__open' : 'skills__content skills__close'} onClick={toggleBackTab}>
                    <div className="skills__header">
                        <i className="uil uil-servers skills__icon"></i>

                        <div>
                            <h2 className="skills__title">Backend Development</h2>
                        </div>
                        <i className="uil uil-angle-down skills__arrow"></i>
                    </div>
                    
                    <div className="skills__list grid">
                        {
                            backEndSkills.map((item, idx) => (
                                <SkillsList key={idx} value={item}/>
                            ))
                        }
                    </div>

                </div>
                <div className={cloudTab ? 'skills__content skills__open' : 'skills__content skills__close'} onClick={toggleCloudTab}>
                    <div className="skills__header">
                        <i className="uil uil-cloud-database-tree skills__icon"></i>

                        <div>
                            <h2 className="skills__title">Development Tools & Env</h2>
                        </div>
                        <i className="uil uil-angle-down skills__arrow"></i>
                    </div>

                    <div className="skills__list grid">
                        {
                            cloudSkills.map((item, idx) => (
                                <SkillsList key={idx} value={item}/>
                            ))
                        }
                    </div>

                </div>
            </div>
        </section>
            
    )
}

export default Skill;